<h2 mat-dialog-title>{{data.titulo}}</h2>
<div mat-dialog-content class="mat-typography">
  <p>{{data.mensagem}}</p>
  <p>{{data.detalhe}}</p>
</div>
<div mat-dialog-actions class="mat-dialog-actions-align-end" style="padding-left: 24px;">
  <button 
    mat-button 
    mat-dialog-close 
    color="primary"
    style="margin-right: 14px;"
    >Fechar</button>
</div>
